import _ from 'lodash'

class DetailResultService {
  constructor(Record, RelatedDocuments) {
    this.Record = Record
    this.record = null
    this.RelatedDocuments = RelatedDocuments
  }

  queryById(recordId, callback) {
    this.record = this.Record.get({recordId: recordId})
    return this.record
  }

  queryRelatedDocuments(record) {
    if(record.causeNumber) {
      this.relatedDocuments = this.RelatedDocuments.queryOkAppOrders({id: record.causeNumber})
    } else if(record.apiNumber) {
      this.relatedDocuments = this.RelatedDocuments.queryOkDrilling({id: record.apiNumber})
    } else {
      this.relatedDocuments = undefined
    }
    return this.relatedDocuments
  }

  queryRespondents(scope) {
    const filter = {
      filter: {
        'causeNumber': scope.record.causeNumber,
        'section': scope.record.section,
        'township': scope.record.township,
        'range': scope.record.range,
        'meridian': scope.record.meridian,
        'typeOfDocument': 'Respondent'
      }
    }
    const respondents = this.Record.query(filter)
    respondents.$promise.then(r => r, e => scope.error = e)
    return respondents
  }
}

DetailResultService.$inject = ['Record', 'RelatedDocuments']

export default DetailResultService
